// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React from 'react';
interface RequiredInputProps extends React.PropsWithChildren<{}>, HtmlInputElementAttributes {
    onChangeCallback?: any;
    className: string;
    readOnly?: boolean;
}

interface RequiredInputState {
    valid: boolean;
}

class RequiredInput extends React.Component<RequiredInputProps, RequiredInputState> {

    constructor(props: RequiredInputProps) {
        super(props);

        this.state = {
            valid: true
        };
    }

    private _onChange = (event: any) => {
        this.props.onChangeCallback(event);
        this.setState({ valid: true });   
    }

    public isValid = (validationFunction: any) => {
        var valid = validationFunction(this.props.value);
        this.setState({ valid: valid });
        return valid;
    }

    render() {
        return (
            <div className='required-input'>
                <input type={this.props.type} id={this.props.id} className={this.props.className} readOnly={this.props.readOnly}
                    placeholder={this.props.placeholder} value={this.props.value} name={this.props.name} onChange={this._onChange}></input >
                <span className={ (this.state.valid ? 'valid' : ' invalid') }><span className='icon-exclaimation'></span>{InovxLoader.t("common:message.requiredInput")}</span>
            </div>
        );
    }
}

export default RequiredInput;